export const manifest = {
  screens: {
    scr_xm2j0w: { name: "Deck 1 — Cover", route: "/", state: {"index":0}, position: {"x":160,"y":10120} },
    scr_i3lw0c: { name: "Deck 2 — Market shift", route: "/", state: {"index":1}, position: {"x":1560,"y":10120} },
    scr_ypd8z3: { name: "Deck 3 — The problem", route: "/", state: {"index":2}, position: {"x":2960,"y":10120} },
    scr_nt626j: { name: "Deck 4 — Traditional flow", route: "/", state: {"index":3}, position: {"x":4360,"y":10120} },
    scr_9jt8je: { name: "Deck 5 — Talab experience", route: "/", state: {"index":4}, position: {"x":5760,"y":10120} },
    scr_bee2b4: { name: "Deck 6 — AI sales agent", route: "/", state: {"index":5}, position: {"x":7160,"y":10120} },
    scr_i7phkf: { name: "Deck 7 — Onboarding", route: "/", state: {"index":6}, position: {"x":12760,"y":10120} },
    scr_loa1gz: { name: "Deck 8 — Benefits", route: "/", state: {"index":7}, position: {"x":8560,"y":10120} },
    scr_2gwnwn: { name: "Deck 9 — Go-to-market", route: "/", state: {"index":8}, position: {"x":9960,"y":10120} },
    scr_dh4ku5: { name: "Deck 10 — Closing", route: "/", state: {"index":9}, position: {"x":11360,"y":10120} },
    scr_l02mo4: { name: "Discover (Talab app)", route: "/app", position: {"x":160,"y":220} },
    scr_gymxya: { name: "Listing Detail", route: "/listing/1", position: {"x":1560,"y":220} },
    scr_jal5pd: { name: "Requests", route: "/requests", position: {"x":160,"y":2200} },
    scr_mcy6yt: { name: "Matches", route: "/matches", position: {"x":1560,"y":2200} },
    scr_7p4xuz: { name: "Saved", route: "/saved", position: {"x":2960,"y":2200} },
    scr_kafk7o: { name: "Messages", route: "/messages", position: {"x":160,"y":4180} },
    scr_44bnf7: { name: "My AI", route: "/my-ai", position: {"x":160,"y":6160} },
    scr_wsv9wy: { name: "Profile", route: "/profile", position: {"x":1560,"y":6160} },
    scr_4jfeec: { name: "Sell Flow", route: "/sell", position: {"x":160,"y":8140} },
    scr_uzftxh: { name: "My Shop (Easylease)", route: "/shop/easylease", position: {"x":1560,"y":8140} },
    scr_wbzxho: { name: "Help", route: "/help", position: {"x":2960,"y":6160} },
  },
  sections: {
    sec_9ohgbq: { name: "Discovery & Browsing", x: 0, y: 0, width: 2920, height: 1180 },
    sec_12y8x8: { name: "My Activity", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_ho4195: { name: "Messaging", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_tqp4jy: { name: "Account & Settings", x: 0, y: 5940, width: 4320, height: 1180 },
    sec_ow2brx: { name: "Selling", x: 0, y: 7920, width: 2920, height: 1180 },
    sec_1218t8: { name: "Pitch Deck", x: 0, y: 9900, width: 14120, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_9ohgbq", children: [
      { kind: "screen", id: "scr_l02mo4" },
      { kind: "screen", id: "scr_gymxya" },
    ] },
    { kind: "section", id: "sec_12y8x8", children: [
      { kind: "screen", id: "scr_jal5pd" },
      { kind: "screen", id: "scr_mcy6yt" },
      { kind: "screen", id: "scr_7p4xuz" },
    ] },
    { kind: "section", id: "sec_ho4195", children: [
      { kind: "screen", id: "scr_kafk7o" },
    ] },
    { kind: "section", id: "sec_tqp4jy", children: [
      { kind: "screen", id: "scr_44bnf7" },
      { kind: "screen", id: "scr_wsv9wy" },
      { kind: "screen", id: "scr_wbzxho" },
    ] },
    { kind: "section", id: "sec_ow2brx", children: [
      { kind: "screen", id: "scr_4jfeec" },
      { kind: "screen", id: "scr_uzftxh" },
    ] },
    { kind: "section", id: "sec_1218t8", children: [
      { kind: "screen", id: "scr_xm2j0w" },
      { kind: "screen", id: "scr_i3lw0c" },
      { kind: "screen", id: "scr_ypd8z3" },
      { kind: "screen", id: "scr_nt626j" },
      { kind: "screen", id: "scr_9jt8je" },
      { kind: "screen", id: "scr_bee2b4" },
      { kind: "screen", id: "scr_loa1gz" },
      { kind: "screen", id: "scr_2gwnwn" },
      { kind: "screen", id: "scr_dh4ku5" },
      { kind: "screen", id: "scr_i7phkf" },
    ] },
  ],
}
